import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useChatStore } from '../../../state/store/chat/use-chat-store';

interface ChangeMessageProps {
    currentMessageIndex: number;
    totalMessageCount: number;
    recordId: string;
    isGenerating?: boolean;
}

export const ChangeMessage = ({ currentMessageIndex, totalMessageCount, recordId, isGenerating }: ChangeMessageProps) => {
    const { changeActiveGenerationIndex } = useChatStore();

    if (isGenerating) {
        return null;
    }

    const handleClick = (index: number) => {
        if (index < 0 || index >= totalMessageCount) return;
        changeActiveGenerationIndex(recordId, index);
    };

    return (
        <div className='flex items-center gap-0'>
            <button onClick={() => handleClick(currentMessageIndex - 1)} className="flex items-center justify-center rounded-lg h-8 w-8 p-0 hover:bg-muted disabled:pointer-events-none disabled:opacity-50" disabled={currentMessageIndex === 0}>
                <ChevronLeft size={16} />
            </button>
            <p className='text-sm min-w-[30px] max-w-[50px]'>{currentMessageIndex + 1} / {totalMessageCount}</p>
            <button onClick={() => handleClick(currentMessageIndex + 1)} className="flex items-center justify-center rounded-lg h-8 w-8 p-0 hover:bg-muted disabled:pointer-events-none disabled:opacity-50" disabled={currentMessageIndex === totalMessageCount - 1}>
                <ChevronRight size={16} />
            </button>
        </div>
    );
};